import { ProfileAvatar } from "#profile-avatar";
import { LearnFlashcardShell } from "@-/dev.improve.haniverse.components.ui.learn-card-shell";
import type { ComponentProps } from "react";

/** The drawer's miniature version of the profile's Learn card. */
export function ProfileAvatarCard({ user }: Pick<ComponentProps<typeof ProfileAvatar>, "user">) {
  return (
    <LearnFlashcardShell
      className="h-16 w-12 -rotate-3 shadow-sm"
      contentClassName="p-1"
      testID="profile-avatar-card"
    >
      <ProfileAvatar card user={user} />
    </LearnFlashcardShell>
  );
}
